	<template functional>
		<div
			v-html="$options.methods.buildHTMLMixin(props)"
			style="margin: 0; padding: 0; height: 100%;"
			@mouseenter="$options.methods.showTooltip($event, $options, props, listeners, true)"
			@mousemove="$options.methods.onMouseMove($event, props, listeners)"
			@mouseleave="$options.methods.showTooltip($event, $options, props, listeners, false)"
			@click="$options.methods.onDaySelected($event, props, listeners)">
		</div>
</template>

<script>
import { Constants } from '../Constants.js';
import CalendarDayFactory from './CalendarDayFactory.js';

export default {
	name: 'CalendarDay',
	mixins: [CalendarDayFactory],
	props: {
		index: Number,
		type: Number,
		data: Object, 
		employee: Object,
		vacation: Array,
		requests: Array,
		onlyVacationData: Boolean,
		calendars: Array,
		projects: Array,
		isDisabled: Boolean,
		isCheckinDisabled: Boolean,
		isCalendarVisible: Boolean,
		isVacation: Boolean,
		vac: Object,
		colors: Array,
		tips: Array,
		tooltip: Object,
		hasTooltip: Boolean,
		projectsTextAndColor: Array,
		dayRequests: Array,
		showTooltipTimeoutId: Number,
	},
		methods: {
			showTooltip(event, $options, props, listeners, show) {		
				if (props.type === Constants.WEEKLYDAY_TYPE) {
					if (show) {
						this.updateWeeklyRequestTooltip(event, props, listeners);
					} else {
						props.activeRequestTooltipIndex = null;
						listeners['hide-tooltip']();
					}
					return;
				}

				if (!props.hasTooltip) {
					return;
				}

			if (show) {
				props.showTooltipTimeoutId = setTimeout(function() {
					listeners['show-tooltip']({ index: props.index, text: $options.methods.getTooltipText(props) });
				}, 200);
				return;
			}

				clearTimeout(props.showTooltipTimeoutId);
				listeners['hide-tooltip']();
			},
			onMouseMove(event, props, listeners) {
				if (props.type !== Constants.WEEKLYDAY_TYPE) {
					return;
				}

				this.updateWeeklyRequestTooltip(event, props, listeners);
			},
			updateWeeklyRequestTooltip(event, props, listeners) {
				const target = event && event.target && event.target.closest
					? event.target.closest('[data-calendar-request-index]')
					: null;

				if (!target) {
					if (props.activeRequestTooltipIndex !== null && props.activeRequestTooltipIndex !== undefined) {
						props.activeRequestTooltipIndex = null;
						listeners['hide-tooltip']();
					}
					return;
				}

				const requestIndex = parseInt(target.getAttribute('data-calendar-request-index'), 10);
				if (isNaN(requestIndex) || !props.dayRequests || !props.dayRequests[requestIndex]) {
					return;
				}

				if (props.activeRequestTooltipIndex === requestIndex) {
					return;
				}

				props.activeRequestTooltipIndex = requestIndex;
				const tooltipText = this.getRequestStatusText(props.dayRequests[requestIndex].recordStatus);
				if (tooltipText) {
					listeners['show-tooltip']({ index: props.index, text: tooltipText });
				}
			},
			getRequestStatusText(recordStatus) {
				if (!window.$vue || !window.$vue.$t) {
					return '';
				}

				switch (recordStatus) {
					case Constants.REQUEST_PREPARING:
						return window.$vue.$t('wkt.admin.procedures.request.preparing');
					case Constants.REQUEST_PENDING:
						return window.$vue.$t('wkt.admin.procedures.request.pending');
					case Constants.REQUEST_APPROVED:
						return window.$vue.$t('wkt.admin.procedures.request.approved');
					case Constants.REQUEST_DECLINED:
						return window.$vue.$t('wkt.admin.procedures.request.denied');
					case Constants.REQUEST_CANCELED:
						return window.$vue.$t('wkt.admin.procedures.request.canceled');
					case Constants.REQUEST_PROCESSED:
						return window.$vue.$t('wkt.admin.procedures.request.processed');
					default:
						return '';
				}
			},
			onDaySelected(event, props, listeners) {
				if (props.isDisabled) {
					return;
				}

				if (props.type === Constants.WEEKLYDAY_TYPE && props.dayRequests && props.dayRequests.length > 0) {
					const target = event && event.target && event.target.closest
						? event.target.closest('[data-calendar-request-index]')
						: null;

					if (target) {
						const requestIndex = parseInt(target.getAttribute('data-calendar-request-index'), 10);
						if (!isNaN(requestIndex) && props.dayRequests[requestIndex]) {
							listeners['day-selected']({ employee: props.employee, calendar: props.data, vacation: props.dayRequests[requestIndex], isRequest: true });
							return;
						}
					}

					// En celdas con solicitudes, un click fuera del enlace mantiene la edición de jornada.
					// por lo que dejamos que siga el flujo
				}
				
				if ((props.type === Constants.MONTHLYDAY_TYPE || props.type === Constants.WEEKLYDAY_TYPE) && props.isVacation) {
					listeners['show-menu']({ index: props.index, day: { employee: props.employee, calendar: props.data, vacation: props.vac } });
					return;
			}

			if (props.type === Constants.MONTHLYDAY_TYPE) {
				listeners['day-selected']({ employee: props.employee, calendar: props.data, vacation: null });
			} else if (props.type === Constants.WEEKLYDAY_TYPE) {
				listeners['day-selected']({ employee: props.employee, calendar: props.data, vacation: props.vac });
			} else if (props.type === Constants.HOLLYDAY_TYPE) {
				listeners['day-selected']({ employee: props.employee, calendar: props.data, vacation: props.vac });
			}
		},
		getTooltipText(props) {
			if (props.tooltip) {
				return props.tooltip;
			}

			let text = '';

			for (let i = 0; i < props.tips.length; i++) {
				const tip = props.tips[i];
				if (text && text.length > 0) {
					text +=  '  |  ';
				}	
				text += tip;
			}

			return text;
		},
		buildHTMLMixin(props) {
			return this.buildHTML(props);
		},
	}
}
</script>
